import { createFileRoute } from '@tanstack/react-router'
import { useT } from '@/shared/i18n'
import { useModules } from '@/shared/modules'
import { EmptyState } from '@/shared/ui'

export const Route = createFileRoute('/app/')({
  component: HomePage,
})

/** Placeholder start page. Product capabilities (fleet overview first) replace it. */
function HomePage() {
  const t = useT()
  const modules = useModules()
  return (
    <section aria-labelledby="home-title" className="mx-auto flex max-w-3xl flex-col gap-4 p-6">
      <h1 id="home-title" className="text-2xl font-semibold">
        {t('home.title')}
      </h1>
      <p className="text-sm text-muted-foreground">
        {t(modules.length === 1 ? 'home.moduleCountOne' : 'home.moduleCountMany', {
          count: modules.length,
        })}
      </p>
      <EmptyState
        title={t('home.emptyTitle')}
        description={t('home.emptyDescription')}
        className="rounded-lg border"
      />
    </section>
  )
}
